/**
 * Hell oder dunkel.
 *
 * Das liegt getrennt vom Thema (`thema.ts`): Ansicht und Helligkeit lassen
 * sich unabhängig umschalten, und beide Werte stehen unter eigenen Schlüsseln
 * im Speicher.
 *
 * Vorher stand dieselbe Logik zweimal in `index.tsx` – einmal beim Start,
 * einmal im `storage`-Ereignis – und der Start fing seinen Fehler mit einem
 * leeren `catch {}` ab. Ein verschluckter Fehler ist hier besonders
 * unangenehm: Im privaten Fenster wirft `localStorage`, die Ansicht hängt
 * dann auf hell, und es gibt keinen Hinweis darauf, warum.
 */

export const DUNKEL_SCHLUESSEL = 'theme';

/** Im Speicher steht die Zeichenkette 'dark' oder 'light'. */
export const istDunkel = (wert: string | null): boolean => wert === 'dark';

/**
 * Liest die gespeicherte Helligkeit.
 *
 * Scheitert der Zugriff, gilt hell. Das ist kein Fehler, der jemanden
 * aufhalten sollte – ohne Speicher gilt die Vorgabe, wie in `leseThema()`.
 */
export const leseDunkelmodus = (): boolean => {
  try {
    return istDunkel(localStorage.getItem(DUNKEL_SCHLUESSEL));
  } catch {
    return false;
  }
};

/**
 * Schreibt die Helligkeit ins Dokument.
 *
 * An `documentElement` **und** `body`: Der Altbestand hängt an `body.dark`,
 * die neueren Regeln an `:root.dark`. Nur eines zu setzen lässt jeweils die
 * andere Hälfte der Oberfläche in der falschen Helligkeit stehen.
 */
export const setzeDunkelmodus = (dunkel: boolean): void => {
  if (typeof document === 'undefined') return;
  document.documentElement.classList.toggle('dark', dunkel);
  document.body.classList.toggle('dark', dunkel);
};
